module.exports = __webpack_public_path__ + "static/media/position.e9d51581.svg";